import React from 'react';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';

const EventsFilter = ({ open, handleClose, handleApply }) => {
    return (
        <div>
            <Modal isOpen={open} toggle={handleClose}>
                {/* <ModalHeader toggle={handleClose}>Filter Events</ModalHeader> */}
                <ModalBody>
                    <Form inline onSubmit={(e) => e.preventDefault()}>
                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4" for="exampleSelect">
                                Title
                            </Label>
                            <Input className="col-8" id="exampleSelect" name="select" type="text"></Input>
                        </FormGroup>

                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4" for="exampleSelect">
                                News Title
                            </Label>
                            <Input className="col-8" id="exampleSelect" name="select" type="select">
                                <option>News 1</option>
                                <option>News 2</option>
                                <option>News 3</option>
                            </Input>
                        </FormGroup>
                        <FormGroup className="col-12 mb-2">
                            <Label className="col-4" for="exampleSelect">
                                Date
                            </Label>
                            <Input className="col-8" id="exampleSelect" name="select" type="date"></Input>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => handleApply()}>
                        Apply
                    </Button>
                    <Button color="secondary" onClick={() => handleClose()}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default EventsFilter;
